import React, { useState, useRef, useEffect } from "react";
import { produce } from "immer";
import styles from "./styles/QurealTableNew.module.css";



const QurealTableNewView = ({ value: tableData, getContent, table_style = {},
	cell_padding = "8px",
	// border_width = 1,
	border_color = "#ccc",
	input = {}
}) => {




	const border_width = input.borderWidth ?? 1;
	const showHeader = input.showHeader ?? true;




	const border_style = `${border_width ?? 1}px solid ${border_color || "black"}`


	return (
		<div style={table_style}>
			<table
				className={styles.table}
				style={{
					borderStyle: "hidden",
					boxShadow: `0 0 0 ${border_width}px ${border_color}`,
					borderRadius: table_style?.borderRadius || 0,
					fontSize: input.fontSize || 16
				}}
			>
				{showHeader && <thead>
					<tr>
						{tableData.columns.map((col, index) => (
							<th
								key={col.key}
								style={{
									width: `${col.width}%`,
									border: border_style,
									position: "relative",
									// textAlign: "left",
									textAlign: col.textAlign || "left",
									padding: cell_padding
								}}
							>
								{col.name}

							</th>
						))}
					</tr>
				</thead>}
				<tbody>
					{tableData.rows.map((row) => (
						<tr key={row.key}>
							{tableData.columns.map((col) => (
								<td
									key={col.key}
									style={{
										width: `${col.width}%`,
										border: border_style,
										padding: cell_padding,
										outline: "none",
										backgroundColor: "transparent",
										fontWeight: col?.bold ? "bold" : "normal",
										...(tableData?.cellStyles?.[`${row.key}-${col.key}`] || {}),
										textAlign: col.textAlign || "left",
									}}
								>
									{/* {row[col.key]} */}
									{getContent(row[col.key]) ?? " "}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default QurealTableNewView;
